import { useState, useEffect } from 'react';

var MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

function diasRestantesNoMes() {
  var hoje = new Date();
  var ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
  return ultimoDia.getDate() - hoje.getDate();
}

var PODIO_COR = {
  1: { border: '#C9A227', badge: '#C9A227' },
  2: { border: '#9E9E9E', badge: '#9E9E9E' },
  3: { border: '#CD7F32', badge: '#CD7F32' },
};

// ── Ícones ────────────────────────────────────────────────────────────────────
var IconCheck  = function() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>; };
var IconChat   = function() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>; };
// eslint-disable-next-line no-unused-vars
var IconHeart  = function() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>; };
var IconTarget = function() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>; };
var IconFlag   = function() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>; };
var IconStar   = function() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>; };
var IconFlame  = function() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 01-7 7 7 7 0 01-7-7 7.4 7.4 0 01.5-2.5"/></svg>; };
// eslint-disable-next-line no-unused-vars
var IconUsers  = function() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>; };

var REGRAS = [
  { icon: IconCheck,  acao: 'Check-in diário',              pts: 10  },
  { icon: IconChat,   acao: 'Compartilhar reflexão',        pts: 30  },
  { icon: IconTarget, acao: 'Começar um desafio pessoal',   pts: 10  },
  { icon: IconFlag,   acao: 'Concluir desafio',             pts: 20  },
  { icon: IconStar,   acao: 'Concluir desafio com 100%',    pts: 50  },
  { icon: IconCheck,  acao: 'Check-in no 1º dia do mês',   pts: 15  },
  { icon: IconFlame,  acao: '7 dias seguidos',              pts: 20  },
  { icon: IconFlame,  acao: '14 dias seguidos',             pts: 40  },
  { icon: IconFlame,  acao: '30 dias seguidos',             pts: 100 },
  { icon: IconFlame,  acao: '100 dias seguidos',            pts: 200 },
];

// ── Modal de Regras ───────────────────────────────────────────────────────────
function ModalRegras({ onFechar }) {
  useEffect(function() {
    var prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    function onKey(e) { if (e.key === 'Escape') onFechar(); }
    document.addEventListener('keydown', onKey);
    return function() {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [onFechar]);

  return (
    <div onClick={onFechar} style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, zIndex: 1000, background: 'rgba(20,18,40,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 16px' }}>
      <div onClick={function(e) { e.stopPropagation(); }} style={{ background: 'var(--surface)', borderRadius: 'var(--r-xl)', width: '100%', maxWidth: 400, boxShadow: '0 8px 40px rgba(0,0,0,0.22)', maxHeight: '85vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 20px 0' }}>
          <h3 style={{ margin: 0, fontSize: '1rem', fontFamily: "'Cormorant Garamond', Georgia, serif", color: 'var(--primary)', fontWeight: 600 }}>Como ganhar pontos</h3>
          <button onClick={onFechar} style={{ background: 'var(--border)', border: 'none', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', flexShrink: 0 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style={{ padding: '12px 20px 20px' }}>
          {REGRAS.map(function(r) {
            var Icon = r.icon;
            return (
              <div key={r.acao} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '11px 0', borderBottom: '1px solid var(--border)' }}>
                <span style={{ color: 'var(--primary)', flexShrink: 0, display: 'flex', alignItems: 'center' }}><Icon /></span>
                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.875rem', color: 'var(--text)', flex: 1 }}>{r.acao}</span>
                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.875rem', fontWeight: 700, color: 'var(--primary)', whiteSpace: 'nowrap' }}>+{r.pts} pts</span>
              </div>
            );
          })}
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 14, marginBottom: 0, lineHeight: 1.5 }}>
            O ranking reinicia todo mês. Os pontos ficam guardados para rankings especiais no futuro.
          </p>
        </div>
      </div>
    </div>
  );
}

// ── Avatar com badge de posição sobreposto ────────────────────────────────────
function AvatarComBadge({ emoji, size, rank, cor }) {
  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      {/* Círculo do avatar */}
      <div style={{
        width: size, height: size, borderRadius: '50%',
        background: 'var(--lavender-light, #f0eef8)',
        border: '2.5px solid ' + cor.border,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: size * 0.42,
      }}>
        {emoji || '😶'}
      </div>
      {/* Badge numérico sobreposto */}
      <div style={{
        position: 'absolute', bottom: -4, left: '50%', transform: 'translateX(-50%)',
        width: 22, height: 22, borderRadius: '50%',
        background: cor.badge,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '0.72rem', fontWeight: 700, color: '#fff',
        fontFamily: "'DM Sans', sans-serif",
        border: '2px solid var(--bg, #f8f7f4)',
        zIndex: 1,
      }}>
        {rank}
      </div>
    </div>
  );
}

// ── Pódio top 3 — sem caixinha, flutuando no fundo ───────────────────────────
function Podio({ top3 }) {
  var ordem = [top3[1], top3[0], top3[2]].filter(Boolean);
  var ranks = top3[1] ? [2, 1, 3] : [1, 2];
  var sizes = top3[1] ? [72, 90, 66] : [90, 72];

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: 20, padding: '8px 0 28px' }}>
      {ordem.map(function(row, i) {
        var rank = ranks[i];
        var cor = PODIO_COR[rank] || PODIO_COR[3];
        var sz = sizes[i];
        return (
          <div key={row.user_id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0 }}>
            <AvatarComBadge emoji={row.avatar_emoji} size={sz} rank={rank} cor={cor} />
            <p style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '1rem', fontWeight: 600, color: 'var(--primary)', margin: '14px 0 2px', textAlign: 'center', maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {row.display_name}
            </p>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.9rem', color: cor.badge, margin: 0, fontWeight: 700 }}>
              {row.points_this_month} <span style={{ fontWeight: 400, fontSize: '0.72rem', color: 'var(--text-muted)' }}>pts</span>
            </p>
          </div>
        );
      })}
    </div>
  );
}

// ── Linha da lista (4° em diante) ─────────────────────────────────────────────
function LinhaRanking({ row, highlight }) {
  var [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={function() { setHovered(true); }}
      onMouseLeave={function() { setHovered(false); }}
      onTouchStart={function() { setHovered(true); }}
      onTouchEnd={function() { setHovered(false); }}
      onTouchCancel={function() { setHovered(false); }}
      style={{
        display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
        borderRadius: 'var(--r-lg)',
        background: highlight ? 'var(--lavender-light, #f0eef8)' : hovered ? 'rgba(0,0,0,0.03)' : 'transparent',
        border: highlight ? '1.5px solid var(--primary)' : '1px solid transparent',
        marginBottom: 8,
        transition: 'background 0.15s ease',
        cursor: 'default',
      }}>
      <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.8rem', color: 'var(--text-muted)', fontWeight: 500, width: 24, textAlign: 'center', flexShrink: 0 }}>
        {row.rank}°
      </span>
      <div style={{
        width: 38, height: 38, borderRadius: '50%', flexShrink: 0,
        background: 'var(--lavender-light, #f0eef8)',
        border: '2px solid var(--border)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '1.1rem',
      }}>
        {row.avatar_emoji || '😶'}
      </div>
      <span style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '1.05rem', fontWeight: 600, color: 'var(--primary)', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {row.display_name}{highlight ? ' (você)' : ''}
      </span>
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '1rem', fontWeight: 700, color: 'var(--primary)', display: 'block' }}>
          {row.points_this_month}
        </span>
        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.7rem', color: 'var(--text-muted)' }}>pts</span>
      </div>
    </div>
  );
}

// ── Componente principal ─────────────────────────────────────────────────────
export default function Leaderboard({ rows, userOptedIn, onToggleOptIn, loading, userId, userRank, onVerResultado, mesAnteriorNome }) {
  var [showRegras, setShowRegras] = useState(false);
  var mesAtual = MESES[new Date().getMonth()];
  var diasRestantes = diasRestantesNoMes();

  var top3 = rows.slice(0, 3);
  var resto = rows.slice(3);
  var userInTop = rows.some(function(r) { return r.user_id === userId; });

  return (
    <div>
      {showRegras && <ModalRegras onFechar={function() { setShowRegras(false); }} />}

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
        <div>
          <p style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 22, fontWeight: 400, color: 'var(--navy)', margin: 0 }}>
            Ranking de {mesAtual}
          </p>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: 'var(--text-muted)', margin: '2px 0 0' }}>
            {diasRestantes > 0 ? diasRestantes + ' dias restantes' : 'Último dia do mês'}
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6, marginTop: 4 }}>
          <button
            onClick={function() { setShowRegras(true); }}
            style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 'var(--r-full)', padding: '4px 12px', fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: 'var(--text-muted)', cursor: 'pointer' }}
          >
            Regras
          </button>
          {onVerResultado && mesAnteriorNome && (
            <button
              onClick={onVerResultado}
              style={{ background: 'none', border: '1px solid var(--lavender)', borderRadius: 'var(--r-full)', padding: '4px 12px', fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: 'var(--lavender)', cursor: 'pointer', whiteSpace: 'nowrap' }}
            >
              Resultado de {mesAnteriorNome} →
            </button>
          )}
        </div>
      </div>

      {/* Opt-in */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, padding: '10px 14px', borderRadius: 'var(--r-lg)', background: userOptedIn ? 'var(--lavender-light, #f0eef8)' : 'var(--surface)', border: userOptedIn ? '1.5px solid var(--primary)' : '1px solid var(--border)', margin: '12px 0' }}>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.82rem', color: userOptedIn ? 'var(--primary)' : 'var(--text-muted)', margin: 0 }}>
          {userOptedIn ? 'Você aparece no ranking' : 'Quer aparecer no ranking?'}
        </p>
        <button
          onClick={onToggleOptIn}
          style={{ border: userOptedIn ? '1px solid var(--border)' : 'none', borderRadius: 'var(--r-full)', padding: '5px 14px', fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', fontWeight: 600, background: userOptedIn ? 'transparent' : 'var(--primary)', color: userOptedIn ? 'var(--text-muted)' : '#fff', cursor: 'pointer', whiteSpace: 'nowrap' }}
        >
          {userOptedIn ? 'Sair' : 'Participar'}
        </button>
      </div>

      {loading ? (
        <p style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.875rem', padding: '24px 0' }}>Carregando ranking...</p>
      ) : rows.length === 0 ? (
        <p style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.875rem', padding: '24px 0' }}>
          Nenhum membro no ranking ainda. Seja o primeiro.
        </p>
      ) : (
        <>
          {/* Pódio sem caixinha */}
          {top3.length > 0 && <Podio top3={top3} />}

          {/* Divisor sutil antes da lista */}
          {resto.length > 0 && (
            <div style={{ borderTop: '1px solid var(--border)', marginBottom: 12 }} />
          )}

          {/* Lista 4° em diante */}
          {resto.map(function(row) {
            return <LinhaRanking key={row.user_id} row={row} highlight={row.user_id === userId} />;
          })}

          {/* Posição do user fora do top 10 */}
          {userOptedIn && !userInTop && userRank && userRank.points_this_month > 0 && (
            <div style={{ marginTop: 4 }}>
              <div style={{ borderTop: '1px dashed var(--border)', margin: '8px 0', textAlign: 'center' }}>
                <span style={{ background: 'var(--bg, #f8f7f4)', padding: '0 8px', fontFamily: "'DM Sans', sans-serif", fontSize: '0.72rem', color: 'var(--text-muted)' }}>sua posição</span>
              </div>
              <LinhaRanking row={{ ...userRank, display_name: userRank.display_name || 'Você' }} highlight />
            </div>
          )}
        </>
      )}
    </div>
  );
}
